/* eslint-disable prettier/prettier */
// data.js
/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images (default avatar)
import defaultAvatar from "assets/images/team-2.jpg";

// API
import { getClioData } from "apis/api";

export default async function mattersTableData(filters = {}) {
    const { issuedAfter, issuedBefore } = filters;

    try {
        const response = await getClioData(issuedAfter, issuedBefore, "matters");
        const mattersData = JSON.parse(response.body);
        //   console.log(mattersData.data);

        const mattersRows = mattersData.data.map((bill) => ({
            id: bill.id,
            display_number: bill.display_number || "",
            client_id: bill?.client?.id,
            client_name: bill?.client?.name || "",
            client_initials: bill?.client?.initials || "",
            client_type: bill?.client?.type || "",
            client_etag: bill?.client?.etag || "",
            responsible_attorney_id: bill?.responsible_attorney?.id,
            responsible_attorney_etag: bill?.responsible_attorney?.etag || "",
            responsible_attorney_name: bill?.responsible_attorney?.name || "",
            originating_attorney_id: bill?.originating_attorney?.id || 0,
            originating_attorney_etag: bill?.originating_attorney?.etag || "",
            originating_attorney_name: bill?.originating_attorney?.name || "",
        }));

        const mattersColumns = [
            { Header: "id", accessor: "id", align: "center" },
            { Header: "display_number", accessor: "display_number", align: "center" },
            { Header: "client_id", accessor: "client_id", align: "center" },
            { Header: "client_name", accessor: "client_name", align: "center" },
            { Header: "client_initials", accessor: "client_initials", align: "center" },
            { Header: "client_type", accessor: "client_type", align: "center" },
            { Header: "client_etag", accessor: "client_etag", align: "center" },
            { Header: "responsible_attorney_id", accessor: "responsible_attorney_id", align: "center" },
            { Header: "responsible_attorney_etag", accessor: "responsible_attorney_etag", align: "center" },
            { Header: "responsible_attorney_name", accessor: "responsible_attorney_name", align: "center" },
            { Header: "originating_attorney_id", accessor: "originating_attorney_id", align: "center" },
            { Header: "originating_attorney_etag", accessor: "originating_attorney_etag", align: "center" },
            { Header: "originating_attorney_name", accessor: "originating_attorney_name", align: "center" },

        ];

        return { mattersColumns, mattersRows, mattersData };
    } catch (error) {
        console.error("Error in mattersTableData:", error);
        return { mattersRows: [], mattersColumns: [], mattersData: [] };
    }
}
